// IO-241 - Temporary notice shown while our printing partner (Schmitz) is on
// annual leave, warning owners that ordered window signs will ship late. It is
// rendered on the funnel landing page (DeliveryNoticeBanner) and near the
// payment page order summary (DeliveryNoticeCallout); both share this single
// date gate so the visibility window lives in exactly one place.
//
// Per the ticket the notification should show from 20/07/2026 until 26/07/2026
// (26/07 included), then hide itself - no manual removal needed afterwards.
// SHOW_FROM is pulled back to today (17/07) so the notice can be verified before
// release; since we deploy on Monday 20/07 it only becomes visible to users on
// the 20th regardless, so the effective production window stays 20-26 July.
// The window is inclusive of both dates; months are 0-indexed in the Date API.
const SHOW_FROM = new Date(2026, 6, 17); // 17 July 2026 (pre-deploy testing) - effective start is the 20/07 deploy
const SHOW_UNTIL = new Date(2026, 6, 27); // 27 July 2026, 00:00 local (exclusive) -> visible through 26 July inclusive

export function isDeliveryNoticeVisible(): boolean {
    const now = new Date();

    return now >= SHOW_FROM && now < SHOW_UNTIL;
}
